export default "__VITE_ASSET__a17b018d__"